import { MergeTagVariable } from "../../Documents";

export interface EntityMergeTagState {
	isLoading: boolean;
	mergeTags: MergeTagVariable[];
}

export interface MergeTagsState {
	[key: string]: EntityMergeTagState;
}

export const MergeTagListToSkip = ["Receiver"];
export const MergeTagChildrenListToSkip = [
	"Partner.Url",
	"VendorOpportunity.Url",
	"Partner.Password"
];

export interface ComputeMergeTagProps {
	readonly mergeTagVariables: MergeTagVariable[];
	readonly MergeTagListToSkip?: string[];
	readonly isDocumentMessage?: boolean;
	readonly hideReceiverMergeTag?: boolean;
	readonly MergeTagChildrenListToSkip?: string[];
	readonly showShipToAddressMergeTag?: boolean;
}

export enum EMergeTagStatus {
	SUCCESS = "sucess",
	TWOMERGETAGS = "2mergetags",
	ONEMERGETAGWITHNUMBER = "1mergetagandnumber"
}
